/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_bulkUpdateCommitteesRequest } from '../models/api_bulkUpdateCommitteesRequest';
import type { api_createCommitteeAssessorRequest } from '../models/api_createCommitteeAssessorRequest';
import type { api_createCommitteeRequest } from '../models/api_createCommitteeRequest';
import type { api_createCommitteeResponse } from '../models/api_createCommitteeResponse';
import type { api_deleteCommitteeAssessmentRequest } from '../models/api_deleteCommitteeAssessmentRequest';
import type { api_getCommitteeResponse } from '../models/api_getCommitteeResponse';
import type { api_submitAssessmentRequest } from '../models/api_submitAssessmentRequest';
import type { api_submitCommitteeAssessmentRequest } from '../models/api_submitCommitteeAssessmentRequest';
import type { api_updateAssessmentRequest } from '../models/api_updateAssessmentRequest';
import type { api_updateCommitteeAssessorRequest } from '../models/api_updateCommitteeAssessorRequest';
import type { api_updateCommitteeRequest } from '../models/api_updateCommitteeRequest';
import type { db_GetBeneficiaryCommitteeAssessmentRow } from '../models/db_GetBeneficiaryCommitteeAssessmentRow';
import type { db_GetCommitteeAssessorRow } from '../models/db_GetCommitteeAssessorRow';
import type { db_ListAssessorBeneficiariesRow } from '../models/db_ListAssessorBeneficiariesRow';
import type { db_ListBeneficiaryCommitteeAssessmentsRow } from '../models/db_ListBeneficiaryCommitteeAssessmentsRow';
import type { db_ListCommitteesRow } from '../models/db_ListCommitteesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Committees {
    /**
     * Update an assessment record
     * @param body Assessment details
     * @returns void
     * @throws ApiError
     */
    public static submitAssessment(
        body: api_submitAssessmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/assessments',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an assessment record
     * @param id Assessment ID
     * @param body Assessment details
     * @returns void
     * @throws ApiError
     */
    public static updateAssessment(
        id: number,
        body: api_updateAssessmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/assessments/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of committee assessments
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListBeneficiaryCommitteeAssessmentsRow OK
     * @throws ApiError
     */
    public static listCommitteeAssessments(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListBeneficiaryCommitteeAssessmentsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committee-assessments',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an assessment record
     * @param body Assessment details
     * @returns void
     * @throws ApiError
     */
    public static submitCommitteeAssessment(
        body: api_submitCommitteeAssessmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committee-assessments',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a committee assessment
     * @param id Committee assessment ID
     * @returns db_GetBeneficiaryCommitteeAssessmentRow OK
     * @throws ApiError
     */
    public static getCommitteeAssessment(
        id: number,
    ): CancelablePromise<db_GetBeneficiaryCommitteeAssessmentRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committee-assessments/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a committee assessment
     * @param id Committee assessment ID
     * @param body Committee assessment details
     * @returns void
     * @throws ApiError
     */
    public static deleteCommitteeAssessment(
        id: number,
        body: api_deleteCommitteeAssessmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/committee-assessments/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a committee assessor
     * @param id Committee assessor ID
     * @returns db_GetCommitteeAssessorRow OK
     * @throws ApiError
     */
    public static getCommitteeAssessor(
        id: number,
    ): CancelablePromise<db_GetCommitteeAssessorRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committee-assessors/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id Committee ID
     * @param body Committee assessor details
     * @returns void
     * @throws ApiError
     */
    public static updateCommitteeAssessor(
        id: number,
        body: api_updateCommitteeAssessorRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/committee-assessors/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of committees
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListCommitteesRow OK
     * @throws ApiError
     */
    public static listCommittees(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListCommitteesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committees',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a committee
     * @param body Committee details
     * @returns api_createCommitteeResponse OK
     * @throws ApiError
     */
    public static createCommittee(
        body: api_createCommitteeRequest,
    ): CancelablePromise<api_createCommitteeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committees',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of beneficiaries assigned to an assessor
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListAssessorBeneficiariesRow OK
     * @throws ApiError
     */
    public static listAssessorBeneficiaries(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListAssessorBeneficiariesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committees/assessor-beneficiaries',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk update committees
     * @param body Bulk update committee details
     * @returns void
     * @throws ApiError
     */
    public static bulkUpdateCommittees(
        body: api_bulkUpdateCommitteesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committees/bulk-update',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a committee
     * @param id Committee ID
     * @returns api_getCommitteeResponse OK
     * @throws ApiError
     */
    public static getCommittee(
        id: number,
    ): CancelablePromise<api_getCommitteeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committees/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a committee
     * @param id Committee ID
     * @returns void
     * @throws ApiError
     */
    public static deleteCommittee(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/committees/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an committee record
     * @param id Committee ID
     * @param body Committee details
     * @returns void
     * @throws ApiError
     */
    public static updateCommittee(
        id: number,
        body: api_updateCommitteeRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/committees/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an committee record
     * @param id Committee ID
     * @param body Committee assessor details
     * @returns any Created
     * @throws ApiError
     */
    public static createCommitteeAssessor(
        id: number,
        body: api_createCommitteeAssessorRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committees/{id}/assessors',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Assign beneficiaries to a committee
     * @param id Committee ID
     * @param body Beneficiary IDs
     * @returns void
     * @throws ApiError
     */
    public static assignBeneficiariesToCommittee(
        id: number,
        body: Array<number>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committees/{id}/beneficiaries',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Standardize committee scores
     * @param id Committee ID
     * @returns void
     * @throws ApiError
     */
    public static standardizeCommitteeScores(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/committees/{id}/standardize-scores',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
